import axios from 'axios';

const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  switch (config.method) {
    case 'post':
      config.headers['Content-Type'] = 'application/ld+json';
      break;
    case 'put':
      config.headers['Content-Type'] = 'application/ld+json';
      break;
    case 'patch':
      config.headers['Content-Type'] = 'application/merge-patch+json';
      break;
    default:
      delete config.headers['Content-Type'];
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 && error.response?.data?.error === '2fa_required') {
      // Clear current user state and redirect to login
      // The AuthContext will handle the redirection based on JWT claims
      window.dispatchEvent(new CustomEvent('2fa-required'));
    }
    return Promise.reject(error);
  }
);

export {axios, api, API_URL};
